function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _ from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';
import featureEnabled from 'shared/helper/feature';
import * as c from './constants';
var initialState = {
  availableDigitalTranslationPurchases: [],
  digitalOrders: [],
  digitalTranslationPurchases: [],
  fileIdentity: '',
  hasUploadedDigitalEdit: false,
  hasUploadedDigitalTranslation: false,
  numberOfUsesAvailable: 0,
  pagination: {},
  status: {
    downloadingFiles: [],
    retrievingDownload: false,
    searchBusy: false,
    searchCompleted: false
  },
  wordCountExceeded: false
};
var languageToTermMap = {
  es_ES: 'spanish-to-english',
  pt_BR: 'portuguese-to-english',
  zh_CN: 'chinese-to-english'
};
var uniqueAllowedLanguages = function uniqueAllowedLanguages(packagesOrPurchases) {
  return _.uniq(packagesOrPurchases.reduce(function (languages, packageOrPurchase) {
    return [].concat(_toConsumableArray(languages), _toConsumableArray(packageOrPurchase.allowedLanguages));
  }, []));
};
var languagesToLanguageOptions = function languagesToLanguageOptions(languages) {
  return languages.reduce(function (options, language) {
    if (language === 'zh_CN' && !featureEnabled('chinese_digital_translation')) {
      return options;
    }
    return [].concat(_toConsumableArray(options), [{
      label: languageToTermMap[language],
      term: languageToTermMap[language],
      value: language
    }]);
  }, []);
};
var digitalOrderColor = function digitalOrderColor(digitalOrder) {
  switch (digitalOrder.status) {
    case c.STATUSES.STATUS_COMPLETED:
      return '#42b22b';
    case c.STATUSES.STATUS_FAILED:
      return '#b4172b';
    default:
      return '#d6d6d6';
  }
};
export var getDigitalPurchases = createSelector(function (_ref) {
  var digitalOrders = _ref.digitalOrders;
  return digitalOrders.digitalTranslationPurchases;
}, function (digitalTranslationPurchases) {
  return digitalTranslationPurchases.filter(function (digitalTranslationPurchase) {
    return digitalTranslationPurchase.numberOfUsesRemaining > 0;
  });
});
export var getAvailableDigitalTranslationPurchases = createSelector(function (_ref2) {
  var digitalOrders = _ref2.digitalOrders;
  return digitalOrders.availableDigitalTranslationPurchases;
}, function (availableDigitalTranslationPurchases) {
  var _availableDigitalTran;
  var priceForOne = ((_availableDigitalTran = availableDigitalTranslationPurchases.find(function (p) {
    return p.numberOfUsesAvailable === 1;
  })) === null || _availableDigitalTran === void 0 ? void 0 : _availableDigitalTran.price) || 0;
  return availableDigitalTranslationPurchases.sort(function (a, b) {
    return a.numberOfUsesAvailable - b.numberOfUsesAvailable;
  }).map(function (p) {
    return _objectSpread(_objectSpread({}, p), {}, {
      fullPrice: p.numberOfUsesAvailable * priceForOne,
      label: p.numberOfUsesAvailable === 1 ? 'digital-translation-package-price-with-languages-label-1' : 'digital-translation-package-price-with-languages-label'
    });
  });
});
export var getLanguageOptionsOfAvailableDigitalTranslationPurchases = createSelector(function (_ref3) {
  var digitalOrders = _ref3.digitalOrders;
  return digitalOrders.availableDigitalTranslationPurchases;
}, function (availableDigitalTranslationPurchases) {
  return languagesToLanguageOptions(uniqueAllowedLanguages(availableDigitalTranslationPurchases));
});
export var getLanguageOptionsOfPurchases = createSelector(getDigitalPurchases, function (digitalTranslationPurchases) {
  return languagesToLanguageOptions(uniqueAllowedLanguages(digitalTranslationPurchases.filter(function (digitalTranslationPurchase) {
    return digitalTranslationPurchase.valid;
  })));
});
export var getDigitalTranslations = createSelector(function (_ref4) {
  var digitalOrders = _ref4.digitalOrders;
  return digitalOrders.digitalOrders;
}, function (digitalOrders) {
  return digitalOrders.filter(function (order) {
    return order.type === c.TYPE_TRANSLATION;
  }).map(function (digitalTranslation) {
    return _objectSpread(_objectSpread({}, digitalTranslation), {}, {
      color: digitalOrderColor(digitalTranslation),
      completed: digitalTranslation.status === c.STATUSES.STATUS_COMPLETED,
      finishedProcessing: digitalTranslation.status !== c.STATUSES.STATUS_PROCESSING,
      failed: digitalTranslation.status === c.STATUSES.STATUS_FAILED,
      processing: digitalTranslation.status === c.STATUSES.STATUS_PROCESSING,
      createdAt: moment(digitalTranslation.createdAt).format('YYYY-MM-DD'),
      fileType: "file-type-".concat(digitalTranslation.file.name.split('.').pop().toLowerCase())
    });
  });
});
export var getDigitalTranslationsEnabled = createSelector(function (_ref5) {
  var digitalOrders = _ref5.digitalOrders;
  return digitalOrders.hasUploadedDigitalTranslation;
}, function (_ref6) {
  var digitalOrders = _ref6.digitalOrders;
  return digitalOrders.numberOfUsesAvailable;
}, function (hasUploadedDigitalTranslation, numberOfUsesAvailable) {
  var hasUses = numberOfUsesAvailable > 0;
  return hasUses || hasUploadedDigitalTranslation;
});
export var getTranslationAccessType = createSelector(function (_ref7) {
  var digitalOrders = _ref7.digitalOrders;
  return digitalOrders.numberOfUsesAvailable;
}, function (_ref8) {
  var digitalOrders = _ref8.digitalOrders;
  return digitalOrders.hasUploadedDigitalTranslation;
}, function (numberOfUsesAvailable, hasUploadedDigitalTranslation) {
  if (numberOfUsesAvailable > 0) {
    return c.TRANSLATIONS_ACCESS_TYPE.USES;
  }
  if (hasUploadedDigitalTranslation) {
    return c.TRANSLATIONS_ACCESS_TYPE.PREVIOUS_UPLOADS;
  }
  return c.TRANSLATIONS_ACCESS_TYPE.NONE;
});
export var convertPurchaseToTransactionFormat = function convertPurchaseToTransactionFormat(availableDigitalPurchases, digitalPurchases, receiptCode, affiliation) {
  var digitalPurchase = digitalPurchases.find(function (digitalPurchase) {
    return digitalPurchase.receiptCode === receiptCode;
  });
  if (!digitalPurchase) {
    return null;
  }
  var availableDigitalPurchase = availableDigitalPurchases.find(function (_ref9) {
    var identity = _ref9.identity;
    return identity === digitalPurchase.availablePurchaseIdentity;
  });
  if (!availableDigitalPurchase) {
    return null;
  }
  return {
    identifier: receiptCode,
    total: availableDigitalPurchase.price,
    products: [{
      price: availableDigitalPurchase.price,
      quantity: '1',
      id: receiptCode,
      sku: availableDigitalPurchase.type === c.TYPE_EDITING ? 'Digital Editing Subscription' : 'Digital Translation',
      name: availableDigitalPurchase.name
    }],
    affiliation: affiliation
  };
};
export var getPurchaseInformation = createSelector(function (_ref10) {
  var digitalOrders = _ref10.digitalOrders;
  return digitalOrders.availableDigitalTranslationPurchases;
}, function (_ref11) {
  var digitalOrders = _ref11.digitalOrders;
  return digitalOrders.digitalTranslationPurchases;
}, function (_ref12) {
  var match = _ref12.match;
  return match.params.receiptCode;
}, function (_ref13) {
  var application = _ref13.application;
  return application.companyShortName;
}, convertPurchaseToTransactionFormat);
var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.DIGITAL_ORDER_SEARCH_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchBusy: false,
        searchCompleted: true
      });
    case c.DIGITAL_ORDER_SEARCH_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchBusy: true
      });
    case c.DOWNLOAD_URL_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        retrievingDownload: true,
        downloadingFiles: [].concat(_toConsumableArray(state.downloadingFiles), [action.digitalTranslationIdentity])
      });
    case c.DOWNLOAD_URL_REQUEST_COMPLETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        retrievingDownload: false,
        downloadingFiles: _.pull(state.downloadingFiles, action.digitalTranslationIdentity)
      });
    default:
      return state;
  }
};
var digitalOrders = function digitalOrders() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.digitalOrders;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.DIGITAL_TRANSLATION_ARCHIVED:
      return state.filter(function (ae) {
        return ae.identity !== action.digitalOrderIdentity;
      });
    case c.DIGITAL_ORDER_SEARCH_COMPLETED:
      return action.digitalOrders;
    case c.DIGITAL_ORDERS_UPDATED:
      return state.map(function (digitalOrder) {
        return action.digitalOrders[digitalOrder.identity] || digitalOrder;
      });
    default:
      return state;
  }
};
var digitalTranslationPurchases = function digitalTranslationPurchases() {
  var digitalTranslationPurchases = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.digitalTranslationPurchases;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.DIGITAL_ORDER_CREATED:
      return digitalTranslationPurchases.map(function (digitalTranslationPurchase) {
        var numberOfUsesRemaining = digitalTranslationPurchase.identity === action.digitalPurchaseIdentity ? digitalTranslationPurchase.numberOfUsesRemaining - 1 : digitalTranslationPurchase.numberOfUsesRemaining;
        return _objectSpread(_objectSpread({}, digitalTranslationPurchase), {}, {
          numberOfUsesRemaining: numberOfUsesRemaining
        });
      });
    default:
      return digitalTranslationPurchases;
  }
};
export var digitalOrdersReducer = function digitalOrdersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.DIGITAL_TRANSLATION_ARCHIVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        digitalOrders: digitalOrders(state.digitalOrders, action)
      });
    case c.DIGITAL_ORDER_CREATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        numberOfUsesAvailable: state.numberOfUsesAvailable - 1,
        digitalTranslationPurchases: digitalTranslationPurchases(state.digitalTranslationPurchases, action),
        hasUploadedDigitalTranslation: true
      });
    case c.DIGITAL_ORDER_CREATION_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        wordCountExceeded: false
      });
    case c.DIGITAL_ORDER_WORD_COUNT_EXCEEDED:
      return _objectSpread(_objectSpread({}, state), {}, {
        fileIdentity: action.fileIdentity,
        wordCountExceeded: true
      });
    case c.DIGITAL_ORDER_SEARCH_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        digitalOrders: digitalOrders(state.digitalOrders, action),
        pagination: action.pagination,
        status: status(state.status, action)
      });
    case c.DIGITAL_ORDERS_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        digitalOrders: digitalOrders(state.digitalOrders, action)
      });
    case c.DIGITAL_ORDER_SEARCH_REQUESTED:
    case c.DOWNLOAD_URL_REQUESTED:
    case c.DOWNLOAD_URL_REQUEST_COMPLETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action)
      });
    case c.DIGITAL_ORDERS_DISPLAY_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        availableDigitalTranslationPurchases: action.availableDigitalTranslationPurchases,
        digitalTranslationPurchases: action.digitalTranslationPurchases,
        hasUploadedDigitalEdit: action.hasUploadedDigitalEdit,
        hasUploadedDigitalTranslation: action.hasUploadedDigitalTranslation,
        numberOfUsesAvailable: action.numberOfUsesAvailable
      });
    default:
      return state;
  }
};
export default digitalOrdersReducer;